<template>
  <div>
    <PricingV2 v-if="$config.platform === 'ds' && $config.project === 'site' && $store.state.tests.tests.pricing === 1" :page-data="pageData" />
    <Pricing v-else :page-data="pageData" />
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import { loadHotJar } from '@itbpbg/lms-components/src/utils/helper';
import PricingV2 from '@itbpbg/lms-components/src/Pricing/PricingPageV2.vue';
import Pricing from '../components/Pricing/PricingPage.vue';

export default {
  components: {
    Pricing, PricingV2,
  },
  mixins: [global],
  async asyncData({
    $axios, route, $config, store,
  }) {
    const [faqResults, page, stats] = await Promise.all([
      $axios.$get('/faq/groups/pricing').catch(() => false),
      $axios.$get(`/pages/${route.fullPath}?ab-test=${Date.now()}`),
      $axios.$get('/stats/courses?reduced=1'),
      store.dispatch('subscriptions/fetchPrices'),
    ]);

    if (page.tests) {
      store.dispatch('tests/addUserTests', page.tests);
    }

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    return {
      pageData: {
        faqResults,
        page,
        stats,
      },
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.pageData.page },
    ]);

    return {
      titleTemplate: `${this.pageData.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.pageData.page),
      script: [linkedData],
    };
  },
  mounted() {
    if (this.$config.platform === 'ds') {
      loadHotJar();
    }
  },
};
</script>
